<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.billing">
  <app-popup-header title="{{localService.languageContent.billing.header_not_accept}}"></app-popup-header>
  <div class="modal-body" *ngIf="products" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-12" style="color: maroon; text-align: justify;">
        &nbsp;&nbsp;{{localService.languageContent.billing.not_accept_reason}}
      </div>
    </div>
    <div class="row">
      <div class="col-12" style="color:red;text-align:center;">
        {{status == 22 ? localService.languageContent.billing.serial_num_incorrect : (status == 23 ?
        localService.languageContent.billing.insufficient_stock : 'NA')}}
      </div>
    </div>
    <div class="row styled_row" *ngFor="let item of products">
      <div class="col-2 en">
        {{item.details.v2}}&nbsp;-&nbsp;
      </div>
      <div class="col-10">
        <span [ngClass]="localService.getLanguageCode(item.details.v6)">{{item.details.v3}}</span>
        <span class="en" style="font-style: italic;"
          *ngIf="item.details.v15.length > 3">&nbsp;({{item.details.v16}})</span>
      </div>
    </div>
  </div>
</div>